{
  "delete_schedule_version": {
    "title": "Disziplinplan löschen",
    "message": "Durch das Löschen von {{ scheduleVersionName }} werden auch die zugehörigen Ereignisse gelöscht. Möchten Sie den Vorgang fortsetzen?"
  },
  "show_schedule": "Zeitplan anzeigen",
  "delete_schedule": {
    "title": "Wettkampfplan löschen",
    "message": "Durch das Löschen von {{ scheduleVersionName }} werden auch die Zeitpläne und Veranstaltungen der Disziplin gelöscht. Möchten Sie den Vorgang fortsetzen?"
  },
  "toasts": {
    "scheduled_items_start_end_times_affected": "Die Start- und Endzeiten einiger geplanter Termine sind möglicherweise betroffen"
  },
  "other": {
    "no_items_based_on_selection": {
      "Discipline": "Aufgrund der ausgewählten Disziplin können keine Elemente angezeigt werden.",
      "Day": "Aufgrund der Auswahl des Veranstaltungsorts können keine Artikel angezeigt werden."
    }
  },
  "errorMessages": {
    "scheduled_item_must_be_within_session": "Der geplante Artikel muss innerhalb der Start- und Endzeiten der Sitzung liegen",
    "must_end_after_start_time": "Die Veranstaltung muss nach der Startzeit enden"
  },
  "session_form": {
    "medal_header": "Medaillen und Zeremonien",
    "medal_ceremony": "Medaillenverleihung",
    "includes_medal_ceremony": "Inklusive Medaillenverleihung"
  },
  "validation": {
    "startTimeValid": "Die Startzeit sollte aus Sekunden, Minuten und Stunden bestehen",
    "startTimeWithinParent": "Die Startzeit sollte nach der Startzeit des Elternteils liegen",
    "endTimeBeforeStartTime": "Die Startzeit sollte vor der Endzeit liegen",
    "endTimeValid": "Die Endzeit sollte Sekunden, Minuten und Stunden haben",
    "endTimeWithinParent": "Die Endzeit sollte vor der Endzeit des übergeordneten Elements liegen"
  },
  "activity": {
    "titleDeleteUnsaved": "Ungespeicherte Zeile löschen",
    "descriptionDeleteUnsaved": "Sind Sie sicher, dass Sie diese neue Zeile verwerfen möchten?"
  },
  "divisions": "Abteilungen",
  "upload_event_blocks": {
    "title": "Laden Sie Kalenderinhalte hoch",
    "calendar_level": "Kalenderebene",
    "delete_existing": "Bestehende Artikel löschen",
    "delete_existing_confirmation_title": "Bestehende Artikel löschen",
    "delete_existing_confirmation_description": "Sie haben „Bestehende Artikel löschen“ ausgewählt. Dadurch werden alle Ereignisse im Kalender unter der von Ihnen ausgewählten Zeitplanversion gelöscht und durch die von Ihnen bereitgestellten CSV-Werte ersetzt. Dies kann nicht rückgängig gemacht werden. Möchten Sie fortfahren?",
    "csv_validation_errors_subtitle": "Fehler bei der CSV-Validierung"
  },
  "exports": {
    "title": "Optionen für den Export",
    "confirm": "Bestätigen",
    "cancel": "Stornieren",
    "message": "Bitte wählen Sie eine Option zum Exportieren",
    "downloadTitle": "Laden Sie herunter",
    "downloadDescription": "Der ODF-Export wird auf Ihren Computer heruntergeladen",
    "publishedDescription": "Der ODF-Export wird auf {{ exportDestinationName }} veröffentlicht",
    "notAvailable": "Nicht verfügbar"
  },
  "key": {
    "title": "Schlüssel zur Planung der Blockfarben"
  },
  "data_fields": {
    "event_unit_description": "Einheit für Veranstaltungen",
    "event_name": "Ereignis",
    "competition_pahse": "Wettbewerbsphase",
    "gender": "Geschlecht",
    "medal_type": "Art der Medaille",
    "ticketing_code": "Code für den Ticketverkauf",
    "ticketed": "Ticket ausgestellt",
    "discipline": "Disziplin",
    "session_code": "Sitzungscode",
    "session_style": "Stil der Sitzung",
    "session_type": "Art der Sitzung",
    "venue_code": "Code des Veranstaltungsortes",
    "Event": "Veranstaltung",
    "Phase": "Phase",
    "Event unit": "Einheit für Ereignisse",
    "Division": "Abteilung",
    "Owner": "Besitzer",
    "multi_selector": {
      "all": {
        "Discipline": "Alle Disziplinen"
      },
      "none": {
        "Discipline": "Keine Disziplinen"
      },
      "x_selected": {
        "Discipline": "{{ count }} Disziplinen ausgewählt"
      }
    },
    "view_by_day_label": {
      "Discipline": "Tag (Disziplin)"
    }
  },
  "scheduleDoesntExist": {
    "noPermission": "Ein Zeitplan für dieses Projekt wurde nicht erstellt. Sie müssen einen Benutzer mit Administratorrechten bitten, dies für Sie zu tun.",
    "createTitle": "Konfigurieren Sie den Zeitplan für dieses Projekt",
    "createDescription": "Für dieses Projekt wurde kein Zeitplan erstellt. Konfigurieren Sie den Zeitplan mithilfe der folgenden Einstellungen. Wenn Sie sich nicht sicher sind, wie Sie den Zeitplan konfigurieren sollen, wenden Sie sich an den Support:"
  },
  "venueEdit": {
    "parentVenue": "Übergeordneter Veranstaltungsort",
    "venueLocationType": "Art des Standorts des Veranstaltungsortes",
    "topLevelVenueName": "Oberste Ebene",
    "tryDeleteParent": "Entfernen Sie vor dem Löschen die Eltern-ID-Verweise auf diese Zeile",
    "tryEditParent": "{{ count }} Veranstaltungsorte verweisen auf diesen Ort als ihr übergeordnetes Objekt. Entferne diese Verweise, bevor du fortfährst."
  },
  "sidebar": {
    "upload": "Laden Sie Event-Blöcke hoch",
    "deleteListItemMessage": "Sind Sie sicher, dass Sie alle Listeneinträge löschen möchten?",
    "deleteListItemTitle": "Listenelemente löschen"
  }
}